import { useNavigate } from 'react-router';
import { Btn } from '../components/chrome/Buttons.js';

export function Splash() {
  const nav = useNavigate();
  return (
    <div className="splash fade-in">
      <div className="belt" />
      <div className="splash-tag">Trading Card Battle</div>
      <div className="splash-logo">
        SLAMFEST
        <span className="row2">RINGSIDE SHOWDOWN</span>
      </div>
      <div className="splash-cta">
        <Btn variant="primary" block onClick={() => nav('/menu')}>
          ENTER ARENA
        </Btn>
        <div className="splash-meta">
          <span>Edition 06</span>
          <span>·</span>
          <span>2026 Season</span>
        </div>
      </div>
      <div className="splash-foot">Tap anywhere to begin</div>
    </div>
  );
}
